import { render, staticRenderFns } from "./ElementWeightFactChiefSectionTableColumn.vue?vue&type=template&id=0dad665a&scoped=true"
import script from "./ElementWeightFactChiefSectionTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementWeightFactChiefSectionTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementWeightFactChiefSectionTableColumn.vue?vue&type=style&index=0&id=0dad665a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dad665a",
  null
  
)

export default component.exports